export default __webpack_public_path__ + "img/2408b205a3099324c6670dc6065ec54a.svg";